var mapStyle = [
	{
		featureType: 'all',
		elementType: 'geometry.fill',
		stylers: [
			{
				weight: '2.00',
			},
		],
	},
	{
		featureType: 'all',
		elementType: 'geometry.stroke',
		stylers: [
			{
				color: '#9c9c9c',
			},
		],
	},
	{
		featureType: 'all',
		elementType: 'labels.text',
		stylers: [
			{
				visibility: 'on',
			},
		],
	},
	{
		featureType: 'landscape',
		elementType: 'all',
		stylers: [
			{
				color: '#f2f2f2',
			},
		],
	},
	{
		featureType: 'landscape',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#ffffff',
			},
		],
	},
	{
		featureType: 'landscape.man_made',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#ffffff',
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'all',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'all',
		stylers: [
			{
				saturation: -100,
			},
			{
				lightness: 45,
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#eeeeee',
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#7b7b7b',
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'labels.text.stroke',
		stylers: [
			{
				color: '#ffffff',
			},
		],
	},
	{
		featureType: 'road.highway',
		elementType: 'all',
		stylers: [
			{
				visibility: 'simplified',
			},
		],
	},
	{
		featureType: 'road.arterial',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'transit',
		elementType: 'all',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'all',
		stylers: [
			{
				color: '#c9e3e2',
			},
			{
				visibility: 'on',
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#c9e3e2',
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#070707',
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'labels.text.stroke',
		stylers: [
			{
				color: '#ffffff',
			},
		],
	},
];

/*id of map here*/
if ($('#map').length > 0) {
	google.maps.event.addDomListener(window, 'load', initialize_map);
}

function initialize_map() {
	var controlPosition = google.maps.ControlPosition.RIGHT_CENTER;
	var coords_dynamic = jQuery('#map').attr('data-coords');
	var splitedcoords = coords_dynamic.split(',');

	var myLatlng = new google.maps.LatLng(splitedcoords[0], splitedcoords[1]);

	var isDraggable = true;
	var mapOptions = {
		zoom: 12,
		gestureHandling: 'cooperative',
		center: myLatlng,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: mapStyle,
		scrollwheel: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: mapStyle,
	};

	var map = new google.maps.Map(document.getElementById('map'), mapOptions);
	var iconsource = '/wp-content/themes/liveri/assets/images/marker.png'; /*map pointer here*/
	var icons = {
		markericon: {
			icon: iconsource,
		},
	};
	var marker = new google.maps.Marker({
		position: myLatlng,
		map: map,
		icon: {
			url: iconsource,
		},
	});

	marker.setAnimation(google.maps.Animation.BOUNCE);
	setTimeout(function () {
		marker.setAnimation(null);
	}, 1000);

	//Map style is not mandatory
	var styledMap = new google.maps.StyledMapType(mapStyle, {
		name: 'Styled Map',
	});
	map.mapTypes.set('mapStyle', styledMap);
	map.setMapTypeId('mapStyle');
}
